/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIBrand
 */
export interface APIBrand {
    /**
     * 
     * @type {string}
     * @memberof APIBrand
     */
    readonly self: string;
    /**
     * 
     * @type {Date}
     * @memberof APIBrand
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIBrand
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIBrand
     */
    name: string;
}

/**
 * Check if a given object implements the APIBrand interface.
 */
export function instanceOfAPIBrand(value: object): value is APIBrand {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIBrandFromJSON(json: any): APIBrand {
    return APIBrandFromJSONTyped(json, false);
}

export function APIBrandFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBrand {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'name': json['name'],
    };
}

export function APIBrandToJSON(value?: Omit<APIBrand, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

